import React from "react";

const Dashboard = () => {
  return (
    <section className="py-10 bg-white sm:py-16 lg:py-24">
      <div className="max-w-5xl px-4 mx-auto sm:px-6 lg:px-8">
        <div className=" items-center ">
          <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl ml-24">
            Welcome to Dashboard.
          </h2>
          <p className="mt-24 text-base leading-relaxed text-gray-600">
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
